import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-content-between w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Administrare"),
    /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Cereri de înregistrare medici")
  ])
], -1)
const _hoisted_2 = { class: "app-inner-container" }

import { RegisterRequest } from '@/interfaces/RegisterRequest';
import RegisterRequestService from '@/services/RegisterRequestService';
import RegisterRequestList from '@/components/RegisterRequestList.vue';
import { onMounted, ref } from 'vue';
import Card from 'primevue/card';

// Vars definitions

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterRequestListView',
  setup(__props) {

const requests = ref<RegisterRequest[]>();

// Functions definitions
const fetchRequests = async () => {
  try {
    requests.value =
      (await RegisterRequestService.fetchRegisterRequests()) as RegisterRequest[];
  } catch (error) {
    console.error(error as string);
  }
};

// Component actions
onMounted(fetchRequests);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Toast),
        _createVNode(RegisterRequestList, { requests: requests.value }, null, 8, ["requests"])
      ])
    ]),
    _: 1
  }))
}
}

})